import React from 'react';
import { ThemeContext } from '../theme/Theme.jsx';

// Styles
import './ZigZagBoxTitle.scss';

function ZigZagBoxTitle(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		fontSize: context.themeManager.value('zig-zag-box-title', 'fontSize', 'font-size-200'),
	};
	const randomId = parseInt(String(Math.random() * 100000), 10);
	const Headline = props.headlineLevel? props.headlineLevel : 'h1';
	return (
		<Headline className="zig-zag-box__title" style={style} id={props.id ? props.id : randomId}>
			{props.children}
		</Headline>
	);
}

export default ZigZagBoxTitle;
